import { useId, useState, useEffect, useMemo } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

export default function RowRadioButtonsGroup({
  value,
  onChange,
  showAleatorioOption = true,
  showEnarmOption = true,
  showSoloCasosClinicosOption = false,
  showCasosConImagenesOption = false,
  accentColor = '#6366f1',
}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const availableOptions = useMemo(() => {
    const options = showAleatorioOption ? ['aleatorio', 'materias'] : ['materias'];

    if (showEnarmOption) {
      options.push('enarm');
    }

    if (showSoloCasosClinicosOption) {
      options.push('solo_casos_clinicos');
    }

    if (showCasosConImagenesOption) {
      options.push('casos_con_imagenes');
    }

    return options;
  }, [showAleatorioOption, showEnarmOption, showSoloCasosClinicosOption, showCasosConImagenesOption]);
  const fallbackOption = useMemo(() => availableOptions[0] || 'materias', [availableOptions]);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  useEffect(() => {
    if (!availableOptions.includes(selectedValue)) {
      setSelectedValue(fallbackOption);
      onChange(fallbackOption);
    }
  }, [availableOptions, fallbackOption, onChange, selectedValue]);

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
    onChange(newValue);
  };

  const id = useId();

    const labelSx = {
        '& .MuiFormControlLabel-label': {
            fontWeight: 400,
            color: '#4b5563',
            fontSize: '0.875rem',
        },
    };

    const radioSx = {
      color: accentColor,
        '&.Mui-checked': {
        color: accentColor,
        },
    };

  return (
    <>
    <h3 className="text-sm font-semibold mb-2">Modo</h3>
    <FormControl sx={{ width: '100%' }}>
      <RadioGroup
        row
        aria-labelledby={`${id}-label`}
        name="modo-radio-group"
        sx={{ width: '100%', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', columnGap: 1 }}
        value={selectedValue}
        onChange={handleChange}
      >
        {showAleatorioOption && (
          <FormControlLabel
            value="aleatorio"
            control={<Radio sx={radioSx} />}
            label="Aleatorio"
            sx={labelSx}
          />
        )}
        <FormControlLabel
          value="materias"
          control={<Radio sx={radioSx} />}
          label="Por materias"
          sx={labelSx}
        />
        {showEnarmOption && (
          <FormControlLabel
            value="enarm"
            control={<Radio sx={radioSx} />}
            label="ENARM"
            sx={labelSx}
          />
        )}
        {showSoloCasosClinicosOption && (
          <FormControlLabel
            value="solo_casos_clinicos"
            control={<Radio sx={radioSx} />}
            label="Solo casos clinicos"
            sx={labelSx}
          />
        )}
        {showCasosConImagenesOption && (
          <FormControlLabel
            value="casos_con_imagenes"
            control={<Radio sx={radioSx} />}
            label="Casos con imagenes"
            sx={labelSx}
          />
        )}
      </RadioGroup>
    </FormControl>
    </>
  );
}